import $ from "jquery";
import {gsap} from "gsap";
import {isMobile} from "detect-touch-device";
import CustomAnimations from "src/scripts/modules/CustomAnimations";


const animations = new CustomAnimations();
let smoother;

function showPage(duration = 1) {

  gsap.to('.section', {
    rotate: 0,
    duration: duration,
    ease: "expo.out",
    scale: 1,
    y: 0
  });
}
function hidePage(duration = .5) {

  let pageRotation = -4;
  if(isMobile)
  {
    pageRotation = -2;
  }
  gsap.to('.section', {
    rotate: pageRotation,
    duration: duration,
    ease: "expo.out", //ease: "power3.out",
    scale: 1.4,
    y: '-=200px'
  });
}

function showPageCloser(url) {

  hidePage();

  setTimeout(function () {
    scrollTop();
  }, 501);


  var tl1 = gsap.timeline({});
  tl1.set('.pagecloser_logo', {
    alpha:0,
    rotate: -10,
    duration: 0,
    scale: .5}, 0);
  tl1.to('.pagecloser_logo', {
    alpha:1,
    rotate: 0,
    duration: 1,
    scale: 1,
    delay: 0}, 0);

  // pagecloser
  var tl = gsap.timeline({onComplete: showNewPage, onCompleteParams: [url] });
  tl.set('.pagecloser', {
    rotate: -4,
    top: '130%',
    scale: 1.2,
    duration:0}, 0);
  tl.to('.pagecloser', {
    rotate: -4,
    duration: 1,
    ease: "expo.out",
    repeat: 0,
    scale: 1.2,
    top: '0%'}, 0);
  tl.to('.pagecloser', {
    rotate: 0,
    duration: .5,
    ease: "expo.out",
    repeat: 0,
    scale: 1,
    top: '0%'}, .8);
}
function showNewPage(url) {

  if(process.env.NODE_ENV === 'production') {
    var newUrl = url.replace(".html","")
    url = newUrl;
  }

  //alert(process.env.NODE_ENV + ' / ' + url);

  window.location.href = url
}

function scrollTop() {
  smoother = animations.getSmoother();

  if (!isMobile) {
    gsap.to(smoother, {
      scrollTop: -1,
      duration: 0.1,
      ease: "power4.out",
    });
  }
  else {
    gsap.to(window, {
      duration: 0,
      ease: "power4.out",
      scrollTo:{
        y: -1,
        autoKill: false}
    })
  }
}

class Work {
  init() {
    this.initPage();
    this.initListener();
    this.onScroll();
  }

  initPage = () => {

  }

  initListener = () => {

    $('.next_project_btn').click(function(e) {
      e.preventDefault();
      let url = $(this).data('url');

      showPageCloser( url );
    });
  }

  showPage = () => {
    showPage();
  }

  hidePage = () => {
    hidePage();
  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {


        /*
        console.log($(window).scrollTop());

        // default
        $('.top_logo').removeClass('logo_is_black');
        $('.burger_menu').removeClass('burger_menu_is_black');

        if (!isInViewport( $('.profil')))
        {
          $('.top_logo').addClass('logo_is_black');
          $('.burger_menu').addClass('burger_menu_is_black');
        }
        if (!isInViewport( $('.service')))
        {
          $('.top_logo').removeClass('logo_is_black');
          $('.burger_menu').removeClass('burger_menu_is_black');
        }
        if (!isInViewport( $('.work')))
        {
          $('.top_logo').addClass('logo_is_black');
          $('.burger_menu').addClass('burger_menu_is_black');
        }
        if (!isInViewport( $('.kontakt')))
        {
          $('.top_logo').removeClass('logo_is_black');
          $('.burger_menu').removeClass('burger_menu_is_black');
        }

         */

        /*
        // set transform origin
        let scrollTop = $(window).scrollTop();
        let docHeight = $(document).height();
        let winHeight = $(window).height();
        let scrollPercent = (scrollTop) / (docHeight - winHeight);
        let scrollPercentRounded = Math.round(scrollPercent*100);
        let yOrigin = (scrollPercentRounded*.8)+'%';
        console.log(yOrigin);

        $('.page').css({
          //'transform-origin': 'center' + ' ' + yOrigin
        });
        $('.main').css({
          //'transform-origin': 'center' + ' ' + yOrigin
        });

         */
      }).scroll();
  };
}

export default Work;
